import { severitiesActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_SEVERITY,
  FETCHING_SEVERITY,
  FETCH_SEVERITY_ERROR,
  FETCH_SEVERITIES,
  FETCH_SEVERITIESALL,
  FETCHING_SEVERITIES,
  FETCH_SEVERITIES_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_SEVERITY,
  DELETE_SEVERITY,
  ADD_SEVERITY,
  EDIT_SEVERITY,
  FORM_TOUCHED,
  NEW_FORM_SEVERITY,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  SEVERITY_FORM_ERROR,
  RESET_STATE
} = severitiesActions

const initialState = {
  loadingSeverity: false,
  loadingSeverities: false,
  fetchSeverityError: false,
  fetchSeveritiesError: false,
  severities: [],
  order: {
    column: 'nome',
    direction: 1
  },
  severity: {
    nome: ''
  },
  severitiesPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  severityFormErrors: {},
  severityFormTouched: false,
  modalOpen: false
}

const severitySchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    }
  }
}

const SeverityValidate = new ValidateFormObject(severitySchema)

const severities = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_SEVERITY:
      formSchemaType = action.severity._id ? 'edit' : 'add'
      return {
        ...state,
        severity: action.severity,
        severityFormErrors: SeverityValidate.validate({
          formObject: action.severity,
          formSchemaType
        })
      }
    case SEVERITY_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.severity._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        severityFormErrors: SeverityValidate.validate({
          formObject: state.severity,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_SEVERITY:
      return {
        ...state,
        severity: { ...initialState.severity },
        severityFormErrors: SeverityValidate.validate({}),
        severityFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        severityFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_SEVERITY:
      formSchemaType = (action.severity || {})._id ? 'edit' : 'add'
      return {
        ...state,
        severity: action.severity,
        loadingSeverity: false,
        fetchSeverityError: false,
        severityFormTouched: false,
        severityFormErrors: SeverityValidate.validate({
          formObject: action.severity,
          formSchemaType
        })
      }
    case FETCHING_SEVERITY:
      return {
        ...state,
        loadingSeverity: true,
        fetchSeverityError: false
      }
    case DELETE_SEVERITY:
      return {
        ...state,
        loadingSeverities: false,
        fetchSeverityError: false,
        severities: state.severities.map(severity => {
          if (severity._id === (action.severity || {})._id) {
            return action.severity
          }
          return severity
        })
      }
    case FETCH_SEVERITY_ERROR:
      return {
        ...state,
        loadingSeverities: false,
        severity: { ...initialState.severity },
        fetchSeverityError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        severitiesPagination: {
          ...state.severitiesPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        severitiesPagination: {
          ...state.severitiesPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_SEVERITIES:
      return {
        ...state,
        loadingSeverities: false,
        severities: action.severities,
        fetchSeveritiesError: false,
        order: action.order,
        severitiesPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case FETCH_SEVERITIESALL:
      return {
        ...state,
        severities: action.severities
      }
    case EDIT_SEVERITY:
      return {
        ...state,
        severities: state.severities.map(severity => {
          if (severity._id === action.severity._id) {
            return action.severity
          }
          return severity
        }),
        loadingSeverities: false,
        fetchSeverityError: false,
        loadingSeverity: false,
        fetchSeveritiesError: false
      }
    case FETCHING_SEVERITIES:
      return {
        ...state,
        loadingSeverities: true,
        fetchSeveritiesError: false
      }
    case FETCH_SEVERITIES_ERROR:
      return {
        ...state,
        loadingSeverities: false,
        fetchSeveritiesError: action.error,
        loadingSeverity: false
      }
    case ADD_SEVERITY:
      return {
        ...state,
        loadingSeverities: false,
        fetchSeveritiesError: false,
        loadingSeverity: false,
        severities: [...state.severities, action.severity]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default severities



// WEBPACK FOOTER //
// ./src/reducers/severities.js